module.exports = __webpack_public_path__ + "f9ed282b6ee51101709c2e5b2f31eae6.svg";